var React = require('react');

function SignedInUser (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"28","height":"28","rx":"14","fill":"#707070","key":0}),React.createElement("circle",{"cx":"3.5","cy":"3.5","r":"3.5","transform":"matrix(-1 0 0 1 17.5 6.125)","stroke":"white","strokeWidth":"1.3125","key":1}),React.createElement("path",{"d":"M7.875 18.3178C7.875 17.565 8.34825 16.8935 9.05721 16.6403V16.6403C12.2535 15.4987 15.7465 15.4987 18.9428 16.6403V16.6403C19.6518 16.8935 20.125 17.565 20.125 18.3178V19.4689C20.125 20.5079 19.2048 21.306 18.1762 21.1591L17.3411 21.0398C15.1249 20.7232 12.8751 20.7232 10.6589 21.0398L9.82381 21.1591C8.79524 21.306 7.875 20.5079 7.875 19.4689V18.3178Z","stroke":"white","strokeWidth":"1.3125","key":2})]);
}

SignedInUser.defaultProps = {"width":"28","height":"28","viewBox":"0 0 28 28","fill":"none"};

module.exports = SignedInUser;

SignedInUser.default = SignedInUser;
